module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("Outline of the Book")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART I: THE BIBLE AND MISSION")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio2"
  }, [_vm._v("1 SEARCHING FOR A MISSIONAL HERMENEUTIC")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Beyond “Biblical Foundations for Mission”")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Biblical Apologetic for Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Danger of Inadequate Proof-texting")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Beyond Multicultural Hermeneutical Perspectives")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Global Church, Global Hermeneutics")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Mission as a Focus of Hermeneutical Coherence")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Beyond Contextual Theologies and Advocacy Readings")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Contexts and Interests")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Exploding the Missionary Stereotype")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Missional Reading Embraces Liberation")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Beyond Postmodern Hermeneutics")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Plurality Yes; Relativism No")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Christian Mission Has Long Experience of “Postmodern” Challenges")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio2"
  }, [_vm._v("2 SHAPING A MISSIONAL HERMENEUTIC")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Bible as the Product of God’s Mission")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Biblical Authority and Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Authority as Command")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Authority and Reality")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Authority and Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Biblical Indicatives and Imperatives in Mission")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Biblical Theocentric Worldview and the Mission of God")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God with a Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Humanity with a Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Israel with a Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Jesus with a Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Church with a Mission")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("A Hermeneutical Map")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART II: THE GOD OF MISSION")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio2"
  }, [_vm._v("3 THE LIVING GOD MAKES HIMSELF KNOWN IN ISRAEL")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Knowing God Through the Experience of God’s Grace")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Exodus")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Return from Exile")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio4"
  }, [_vm._v("Knowing God Through Exposure to His Judgment")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Egypt")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Israel in Exile")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Nations Under Judgment")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("4 THE LIVING GOD MAKES HIMSELF KNOWN IN JESUS CHRIST")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Jesus Shares the Identity of "), _c('span', {
    staticClass: "small"
  }, [_vm._v("YHWH")])]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Maranatha!")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Kyrios Iēsous")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Jesus Performs the Functions of "), _c('span', {
    staticClass: "small"
  }, [_vm._v("YHWH")])]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Creator")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Ruler")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Judge")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Savior")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Jesus Fulfills the Mission of "), _c('span', {
    staticClass: "small"
  }, [_vm._v("YHWH")])]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God Wills to Be Known Through Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Gospel Carries the Knowledge of God Among the Nations")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Biblical Monotheism and Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Biblical Mission Is Driven by God’s Will to Be Known as God")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Biblical Monotheism Involves Constant Christological Struggle")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Biblical Monotheism Generates Praise")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("5 THE LIVING GOD CONFRONTS IDOLATRY")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Paradoxes of the Gods")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Something or Nothing?")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Idols and Gods as Objects Within Creation")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Idols and Gods as Demons")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Idols and Gods as the Work of Human Hands")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Critique and Hope")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Mission and the Gods")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Recognizing the Most Crucial Distinction")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Discerning the Gods")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Exposing the Gods")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Remembering the Battle Is the Lord’s")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Confronting Idolatry")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Theological Argument")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Evangelistic Engagement")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Pastoral Guidance")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Prophetic Warning")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART III: THE PEOPLE OF MISSION")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("6 GOD’S ELECT PEOPLE: CHOSEN FOR BLESSING")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Paul’s Gospel")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Consider Abraham")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Genesis 12:1-3—A Pivotal Text")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Story So Far")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Genesis 12:1-3—A Closer Look")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Translation and Structure")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Leaving and Blessing")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Countering Babel")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Promise Develops")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Covenantal Obedience and Mission")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("“Go . . . and Be a Blessing”")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Blessing Is Creational and Relational")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Blessing Is Missional and Historical")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Blessing Is Covenantal and Ethical")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Blessing Is Multinational and Christological")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("7 GOD’S PARTICULAR PEOPLE: CHOSEN FOR ALL")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Universality—Old Testament Echoes of Abraham")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Pentateuch")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Historical Books")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Psalms")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Prophets")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Universality—New Testament Echoes of Abraham")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Synoptic Gospels and Acts")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Paul")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Revelation")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("All the Nations in All the Scriptures")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Particularity—“Through You and Your Seed”")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("“Through You”: The Particular Means of God’s Blessing")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Uniqueness of Israel’s Election")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Conclusion: Biblical Election and Mission")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("8 GOD’S MODEL OF REDEMPTION: THE EXODUS")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("“The People You Have Redeemed”")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("God’s Comprehensive Redemption")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Political")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Economic")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Social")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Spiritual")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("God’s Motivated Redemption")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Knowledge of the Oppressed")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Covenant Memory")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Model of Redemption")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Exodus and Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Spiritualizing Interpretation")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Politicizing Interpretation")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Integral Interpretation")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("9 GOD’S MODEL OF RESTORATION: THE JUBILEE")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Jubilee in Context")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Social Angle: Israel’s Kinship System")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Economic Angle: Israel’s System of Land Tenure")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Theological Angle: God’s Land, God’s People")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Practical Provisions of the Jubilee")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Jubilee, Ethics and Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Economic Angle: Access to Resources")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Social Angle: Family Viability")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Theological Angle: A Theology for Evangelism")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Jubilee, Future Hope and Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Looking to the Future")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Looking to Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Looking to the Spirit")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The New Testament and Holistic Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Holistic Mission Flows from Applying the Whole Bible")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Jesus and the Early Church Did Present a Radical Political Challenge")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Centrality of the Cross")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("A Mission-Centered Theology of the Cross")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("A Cross-Centered Theology of Mission")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Practice and Priorities")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Primacy or Ultimacy?")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Evangelism and Social Involvement: Chicken or Egg?")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Holistic Mission Needs the Whole Church")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("10 THE SPAN OF GOD’S MISSIONAL COVENANT")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Noah")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Commitment to All Life on Earth")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Ecological Dimension of Mission")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Abraham")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Canonical Context: Genesis 1—11")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Universality of the Ultimate Goal")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Particularity of the Means")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Sinai")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Mission and God’s Priesthood: Exodus 19:4-6")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Mission and God’s Presence: Leviticus 26:11-13")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Mission and God’s Prognosis: Deuteronomy 27—32")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("David")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("A King in the Purposes of God")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("A King for All Nations")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("A House of Prayer for All Nations")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Great David’s Greater Son")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The New Covenant")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Prophetic Hopes")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Covenantal “Yes” in Christ")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Mission and the Extension of the Covenant to the Nations")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Great Commission as the Command of the New Covenant")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Mission Accomplished as the Climax of the Covenant")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("11 THE LIFE OF GOD’S MISSIONAL PEOPLE")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Missional Ethics and Election—Genesis 18")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Sodom: A Model of Our World")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Abraham: A Model of God’s Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("“The Way of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("”: A Model for God’s People")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Missional Ethics and Redemption—Exodus 19")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Redemptive Initiative")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Universal Ownership")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Israel’s Identity and Responsibility")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Missional Ethics and Covenant—Deuteronomy 4")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Deuteronomy 4:1-40: An Overview")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Visibility of Israel’s Society (Deut 4:6-8)")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Exclusivity of Israel’s Worship (Deut 4:9-31)")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Uniqueness of Israel’s Experience (Deut 4:35)")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Missional Responsibility of Israel’s Obedience")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Missional Ethics and the Church")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Election and Ethics")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Redemption and Ethics")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Covenant and Ethics")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART IV: THE ARENA OF MISSION")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("12 MISSION AND GOD’S EARTH")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Earth Is the Lord’s")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Goodness of Creation")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Sanctity (But Not Divinity) of Creation")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Earth as the Field of God’s Mission and Ours")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Glory as the Goal of Creation")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("God’s Redemption of the Whole Creation")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Care of Creation and Christian Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Creation Care Is an Urgent Issue in Today’s World")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Creation Care Flows from Love and Obedience to God")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_c('span', [_vm._v("Creation Care Exercises Our Priestly and Kingly Role in Relation to the Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Creation Care Tests Our Motivation for Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Creation Care Is a Prophetic Opportunity for the Church")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Creation Care Embodies a Biblical Balance of Compassion and Justice")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("13 MISSION AND GOD’S IMAGE")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Humanity in God’s Image")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Created in God’s Image")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Created for a Task")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Created in Relationship")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Humanity in Rebellion")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Sin Affects Every Dimension of the Human Person")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Sin Affects Human Society and History")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Sin Affects the Whole Environment of Human Life")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("A Paradigm Evil? HIV/AIDS and the Church’s Mission")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Dimensions of Evil in the Context of HIV/AIDS")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Dimensions of Mission in Response to HIV/AIDS")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Ultimacy of Evangelism and the Nonultimacy of Death")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Wisdom and Culture")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("An International Bridge")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("A Creational Ethic")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("An Honest Faith")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("14 GOD AND THE NATIONS IN OLD TESTAMENT VISION")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Nations in Creation and Providence")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Nations Are Part of Created and Redeemed Humanity")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("All Nations Stand Under God’s Judgment")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Any Nation Can Be the Agent of God’s Judgment")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Any Nation Can Be the Recipient of God’s Mercy")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("All Nations’ Histories Are Under God’s Control")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Nations as Witnesses of Israel’s History")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Witnesses of God’s Mighty Acts of Redemption")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Witnesses of Israel’s Covenant Obligations")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Witnesses of God’s Judgment on Israel")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Witnesses of God’s Restoration of Israel")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Nations as Beneficiaries of Israel’s Blessing")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Psalm 47")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Psalm 67")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Nations Will Worship Israel’s God")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Psalms")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Prophets")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Nations Will Be Included in Israel’s Identity")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Registered in God’s City")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Blessed with God’s Salvation")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Accepted in God’s House")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Called by God’s Name")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Joined with God’s People")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("15 GOD AND THE NATIONS IN NEW TESTAMENT MISSION")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("A Missions Mandate in the Old Testament?")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Jesus and the Evangelists")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Jesus and Gentiles")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Evangelists and the Gentiles")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Early Church in Acts")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Peter and Philip")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("James and the Jerusalem Council")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("Paul’s Adoption of the Servant Mission")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("The Apostle Paul")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Nations Are Seeing What God Has Done")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Nations Are Benefiting from What God Has Done")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Nations Are Bringing Their Worship to God")]), _vm._v(" "), _c('p', {
    staticClass: "biblio4"
  }, [_vm._v("The Nations Are Sharing the Identity of Israel")]), _vm._v(" "), _c('p', {
    staticClass: "ibiblio"
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("Bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("Indexes")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce84a63e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/OutlineoftheBook.vue
// module id = 69
// module chunks = 0